import { useEffect, useMemo, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import INSTRUCTORS_QUERY from '../queries/INSTRUCTORS_QUERY';
 
const useILTInstructors = () => {
    const [ instructors, setInstructors ] = useState( [] );
    const [ fetchInstructors, { data, loading, error } ] = useLazyQuery( INSTRUCTORS_QUERY, {
        variables: {
            page: 1,
            limit: 10000,
            orderBy: 'createdAt',
            orderDir: 'desc',
        },
        fetchPolicy: 'network-only'
    } );

    useEffect( () => {
        fetchInstructors();
    }, [] );

    useEffect( () => {
        if ( loading || error || !data || !data.instructors?.edges ) { return; }
        
        try {
            const result = data.instructors.edges.map( i => { 
                return {
                    id: i.node?.id || '',
                    key: i.node?.id || '',
                    name: i.node?.name || '', 
                    title: i.node?.title || '', 
                    description: i.node?.description || '', 
                    emailAddress: i.node?.emailAddress || '', 
                }; 
            } );

            setInstructors( result );
        } catch ( error ) {
            console.error( 'Error parsing instructors', error ); 
            setInstructors( [] );
        }
    }, [ loading, error ] );
   
    return useMemo( () => {
        return {
            instructors,
            instructorsError: error,
            instructorsLoading: loading, 
        };
    }, [ instructors, error, loading ] );
};

export default useILTInstructors;
